module.exports = __webpack_public_path__ + "static/media/red-tag-sale-video-background.f340b447.webp";